module.exports = __webpack_public_path__ + "img/cate5.949ffd16.png";